import { Palette } from 'core/config';
import styled from 'styled-components';

export const PreviewContainer = styled.div<{ draggedOver: boolean; }>`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${({ draggedOver }) => draggedOver && 'opacity: 0.5;'}
`;

export const DragAndDrop = styled.img`
    width: 100px;
    cursor: pointer;
    pointer-events: none;
`;

export const UploadDocumentText = styled.p`
    font: normal normal 900 12px 'SofiaPro-Regular';
    margin: 2px 0;
`;

export const MutedDragAndDropText = styled(UploadDocumentText)`
    font-size: 10px;
    color: ${Palette.DOVE_GREY}};
`;

export const UploadComplete = styled.img`
    width: 90px;
`;
